module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    staticClass: "text-sm font-semibold text-gray-700",
    attrs: {
      "title": 'Join RoundTable',
      "size": "dessassociate_sequence_roundtable",
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "h-full w-full overflow-y-auto py-4"
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "overflow-y-auto h-full px-5"
  }, [_c('div', [_vm._v("\n            Your teacher will give you a code to join in a RoundTable! \n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col px-5 flex-grow h-full"
  }, [_c('div', {
    staticClass: "flex flex-col w-full space-y-1.5 mb-2"
  }, [_c('span', [_vm._v("Enter "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("RoundTable")]), _vm._v(" code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite_code),
      expression: "invite_code"
    }],
    staticClass: "py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-primary",
    attrs: {
      "placeholder": "Enter the code that was provided by the teacher...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.invite_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invite_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "bg-gray-100 py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-primary py-2 flex items-center justify-center space-x-2 text-white font-semibold w-full rounded-md border border-solid border-primary",
    on: {
      "click": _vm.joinRoundtable
    }
  }, [_c('span', [_vm._v("Join RoundTable")]), _vm._v(" "), (_vm.is_joining === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-789da587!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/joinRoundtableModal.vue
// module id = 2419
// module chunks = 61